import {useEffect, useState} from "react";

import {SliderGallerySlideNavigation} from "@pg-design/slider-gallery-module";

import {useGallerySwipeOnboarding} from "./use_gallery_swipe_onboarding";

type SlideChangeHandler = (currentSlideIndex: number, nextSlideIndex: number, navigation?: SliderGallerySlideNavigation) => void;

interface IUseInlineGalleryChromeParams {
    slidesCount: number;
    onSlideChange?: SlideChangeHandler;
}

export const useInlineGalleryChrome = ({slidesCount, onSlideChange}: IUseInlineGalleryChromeParams) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const {dismissOnboarding, shouldShowOnboarding} = useGallerySwipeOnboarding(slidesCount);

    useEffect(() => {
        setActiveIndex((current) => (slidesCount <= 0 ? 0 : Math.min(current, slidesCount - 1)));
    }, [slidesCount]);

    const handleSlideChange: SlideChangeHandler = (currentSlideIndex, nextSlideIndex, navigation) => {
        setActiveIndex(nextSlideIndex);

        if (navigation === SliderGallerySlideNavigation.SWIPE) dismissOnboarding();

        onSlideChange?.(currentSlideIndex, nextSlideIndex, navigation);
    };

    return {
        activeIndex,
        handleSlideChange,
        shouldShowDots: slidesCount > 1,
        shouldShowOnboarding
    };
};
import {useEffect, useState} from "react";

import {SliderGallerySlideNavigation} from "@pg-design/slider-gallery-module";

import {useGallerySwipeOnboarding} from "./use_gallery_swipe_onboarding";

type SlideChangeHandler = (currentSlideIndex: number, nextSlideIndex: number, navigation?: SliderGallerySlideNavigation) => void;

interface IUseInlineGalleryChromeParams {
    slidesCount: number;
    onSlideChange?: SlideChangeHandler;
}

export const useInlineGalleryChrome = ({slidesCount, onSlideChange}: IUseInlineGalleryChromeParams) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const {dismissOnboarding, shouldShowOnboarding} = useGallerySwipeOnboarding(slidesCount);

    useEffect(() => {
        setActiveIndex((current) => (slidesCount <= 0 ? 0 : Math.min(current, slidesCount - 1)));
    }, [slidesCount]);

    const handleSlideChange: SlideChangeHandler = (currentSlideIndex, nextSlideIndex, navigation) => {
        setActiveIndex(nextSlideIndex);

        if (navigation === SliderGallerySlideNavigation.SWIPE) dismissOnboarding();

        onSlideChange?.(currentSlideIndex, nextSlideIndex, navigation);
    };

    return {
        activeIndex,
        handleSlideChange,
        shouldShowDots: slidesCount > 1,
        shouldShowOnboarding
    };
};
